export default __webpack_public_path__ + "images/78b7af3daeabe56b5af4be8943698fcc-googlePlayIcon.png";